import styled from "styled-components/macro";

const FilterIconStyles = styled.svg`
  width: 100%;
`;

const FilterIcon = () => (
  <FilterIconStyles
    width="30"
    height="28"
    viewBox="0 0 30 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Filter Icon"
      d="M2.5572 1C1.69718 1 1 1.69718 1 2.5572V2.5572C1.00263 2.74057 1.07819 2.91547 1.21021 3.04382L11.4124 14.2768C11.5444 14.4052 11.62 14.5801 11.6226 14.7635V24.343C11.6224 24.4733 11.659 24.6011 11.7284 24.7117C11.7978 24.8223 11.8971 24.9114 12.015 24.9687L17.5506 26.9291C17.6575 26.9811 17.776 27.0052 17.8949 26.9991C18.0139 26.993 18.1293 26.9569 18.2302 26.8943C18.3312 26.8317 18.4144 26.7446 18.4721 26.6412C18.5297 26.5378 18.5598 26.4216 18.5596 26.3034V14.6383C18.5789 14.4504 18.669 14.2767 18.8118 14.1517L28.7898 3.07163C28.9218 2.94328 28.9974 2.76837 29 2.58501V2.58501C29 1.70963 28.2904 1 27.415 1H2.5572Z"
      stroke="#757575"
      strokeWidth="2"
    />
  </FilterIconStyles>
);

export default FilterIcon;
